import styled from 'styled-components';

/** A brand's name, bold, ellipsed before it pushes its total off the card. */
export const BrandName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: ${({ theme }) => theme.darkGray};
`;

/** The parts under the bar, side by side, wrapping on a phone. */
export const PartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 20px;
  margin-top: 10px;
`;

export const PartItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

/** The part's colour, the one thing tying a line to its bar segment. */
export const PartDot = styled.span<{ $color: string }>`
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;
